<template>
  <div class="my-3">
    <p class="mb-0 font-weight-bold">Alert Types</p>
    <v-select
      multiple
      label="name"
      :options="allAlertTypes"
      :value="selectedItems"
      @input="updateTags"
      :select-on-tab="true"
      :close-on-select="false"
      :clearSearchOnSelect="false"
    />
  </div>
</template>

<script>
import vSelect from "vue-select";
import { addOrUpdateParameter } from "@/helpers/urlParamsHelper";

export default {
  name: "AlertTypes",

  components: {
    vSelect,
  },

  computed: {
    allAlertTypes: function () {
      return this.$store.getters["search/getAllAlertTypes"];
    },
    selectedItems: function () {
      return this.$store.getters["search/getAlertTypeTags"];
    },
  },

  methods: {
    updateTags(value) {
      this.updateItemsInStore(value);
    },

    updateItemsInStore(value) {
      this.$store.dispatch("search/updateAlertTypes", value);

      // Grabs all but the last item
      const allButLast = value.slice(0, -1);
      // Builds a string for all states
      let allStatesString = "";
      for (let item of allButLast) {
        allStatesString += item.name + "|";
      }

      // Adds the last item to string without the "|" delimiter
      value.length >= 1
        ? (allStatesString += value[value.length - 1].name)
        : "";

      const encodedParams = encodeURI(`${allStatesString}`);
      addOrUpdateParameter("alertTypes", encodedParams);
    },
  },
};
</script>
